import PlatformActions from './PlatformActions'

export default class SPADEFISHActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'FH',
      gameName: 'Zombie Party',
      gameCode: 'SG-FISH-004',
      platform: 'SPADE',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      updateTime,
      requireAmount,
    }) => ({
      ...this.constantTxnData,
      // gameType: 'FH',
      // gameName: 'FishingGod',
      // gameCode: 'SG-FISH-001',
      userId,
      // platform: 'SPADE',
      platformTxId: txnId, // ex: 20211220134123422123496
      roundId: txnId,
      betType: null,
      currency,
      betTime, // ex: 2021-10-01T14:09:37.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: 0,
      updateTime, // ex: 2021-10-01T14:09:37.230+08:00
      requireAmount: requireAmount ?? betAmount,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      // gameType: 'FH',
      // gameName: 'FishingGod',
      // gameCode: 'SG-FISH-001',
      userId,
      // platform: 'SPADE',
      platformTxId: txnId, // ex: 20211018174246056114125
      roundId: txnId,
      updateTime, // ex: 2021-10-01T14:09:37.230+08:00
      betAmount,
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
